//
// Buffer.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./LocationFeature";
import "@sas-dvr/ltjs-commons/maps/GeoEnrichmentResult";
import "@sas-dvr/ltjs-commons/maps/RouteInfo";

var Buffer = createModule("gtl::Buffer", ["gtl::LocationFeature"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getGeoEnrichmentData: [7],
        getGeoEnrichmentResults: [[1]],
        enrichBuffer: [0,[7]],
        reset: [0],
        calculateBuffer: [0,1],
        getAppliedBufferInfo: [1],
        getBufferInfo: [1],
    },
    ,
    ,
]);
export default Buffer;
